import { FC } from "react";
import { AffiliateStatusEnum } from "../../interfaces/endpoints/IAffiliates";
import Status from "../ui/Status";

const statusMap: Record<number, { type: "green" | "orange" | "red" | "gray"; name: string }> = {
  [AffiliateStatusEnum.Pending]: { type: "orange", name: "Ne pritje" },
  [AffiliateStatusEnum.Approved]: { type: "green", name: "Aprovuar" },
  [AffiliateStatusEnum.Rejected]: { type: "red", name: "Refuzuar" },
  [AffiliateStatusEnum.Suspended]: { type: "gray", name: "Pezulluar" }
};

const PayoutStatusMap: Record<number, { type: "green" | "orange" | "red" | "blue"; name: string }> = {
  0: { type: "orange", name: "Ne pritje" },
  1: { type: "green", name: "Aprovuar" },
  3: { type: "red", name: "Refuzuar" }
};

export const AffiliateStatusBadge: FC<{ status: number }> = ({ status }) => {
  const info = statusMap[status] || { type: "gray", name: "I panjohur" };
  return <Status type={info.type} name={info.name} />;
};

export const PayoutStatusBadge: FC<{ status: number }> = ({ status }) => {
  const info = PayoutStatusMap[status] || { type: "gray", name: "I panjohur" };
  return <Status type={info.type} name={info.name} />;
};
